<div>
    <div *ngIf="newIskpi">
        <div class="header-message">Important
            message
        </div>
        <div mat-dialog-content>
        <div >
        None of the variables are selected for analysis.Please select the applicable variable categories to be able to proceed further.
        </div>
        <div class="btnAlign">
            <button (click)="goBack()" class="back" mat-raised-button color="default">Back</button>
            </div>
        </div>
        
    </div>
    <div id="ppp" *ngIf="!newIskpi">


        <div class="header-message" *ngIf="newisEditable == 'false'">Energy
            Comparison
            Baseline</div>
        <div class="header-message" *ngIf="newisEditable == 'true'">Important
            message
        </div>
        <div mat-dialog-content>
            <div class="row">
                <div class="col-md-6">
            <div *ngIf="newisEditable == 'false'">
                <p>
                    Please choose the baseline for energy comparison
                </p>
                <input id="ashr" type="radio" (change)="changeEvent($event)" name="custom" value="ASHRAE" [disabled]='(showTedi && !showEnergy) || (ashraeEnabled !== "Y")'> <label for="ashr">{{ashrae }}</label><br>
                <input id="necb" type="radio" (change)="changeEvent($event)" name="custom" value="NECB" [disabled]="(showTedi && !showEnergy) || necbEnabled !== 'Y'"> <label for="necb">{{necb}}</label><br>
                <input *ngIf="cubase" (change)="changeEvent($event)" id="baseline" type="radio" name="custom"
                    value="Custom Baseline" [disabled]="(showTedi && !showEnergy) || cbEnabled !== 'Y'">
                <label *ngIf="cubase" for="baseline"
                    [ngClass]="{'edit_text':dsbcust == false, 'noedit_text':dsbcust == true}">{{cb}}</label>

                <div  *ngIf="cubase">
                    <div class="cubase" *ngIf='dsbcust'>(Please select
                        all
                        the
                        variables for "Custom Baseline" to be able to select it for energy comparison)</div>
                </div>
            </div>
            </div>
            <div class="col-md-6" *ngIf="newisEditable == 'false' && costChart=='Yes'">
			<div >
                <p>
                    Please choose the options for the results available for display
                </p>
                <input id="euikwh" type="checkbox" [disabled]="!showEnergy" (change)="changeEvent($event)" name="options" value="EUI"> <label for="ashr">EUI (kWh/m2/yr)</label><br>
                <input id="sav" type="checkbox" [disabled]="!showEnergy" (change)="changeEvent($event)" name="options" value="SAVINGS"> <label for="necb">% Energy Savings</label><br>
                 <input id="tedi" type="checkbox" [disabled]="!showTedi" (change)="changeEvent($event)" name="options" value="TEDI"> <label for="necb">TEDI (kWh/m2/yr)</label><br>

            </div>
            </div>
            

            <div *ngIf="newisEditable == 'true'">
                Due to custom changes done in the wizard, Eco matrix application
                needs to run the server side data extrapolation to recalculate
                the results. This process could take upto 10 minutes.<br />

                A notification email upon finishing the extrapolation will be emailed to
                your registered email address.Please check SPAM folders too, just in case !
            </div>
            <!-- <button *ngIf="newisEditable == 'false'" (click)="goBack()" class="back" mat-raised-button
                color="default">Back</button>
            <button [class.actcostStyle]="newisEditable=='true'" id="actcost" (click)="getCost()" type="button" [disabled]="toggleBool==true"
                mat-raised-button color="primary">OK</button> -->
                <div class="col-md-6" *ngIf="costChart=='No'">
				<div >
				<div >
					<div>
						<p>
							Please choose the KPI for comparison
						</p>

					   <input id="euikwh" type="checkbox" name="custom" [disabled]="!showEnergy" value="Eui" (change)="changeCostEvent($event)">
						<label for="ashr">EUI (kWh/m2/yr)</label><br>
						<input id="sav" type="checkbox" name="custom" [disabled]="!showEnergy" value="Savings" (change)="changeCostEvent($event)">
						<label for="ashr">% Energy Savings</label><br>
						<input id="cp" type="checkbox" name="custom" [disabled]="!showEnergy" value="CostPremium" (change)="changeCostEvent($event)">
						<label for="ashr">Cost Premiums </label><br>
						<input id="ghg" type="checkbox" name="custom" [disabled]="!showEnergy" value="GHG" (change)="changeCostEvent($event)"> <label
							for="necb">GHG
							Reductions</label><br>
						<input id="op" type="checkbox" name="custom" [disabled]="!showEnergy" value="OpCost" (change)="changeCostEvent($event)"> <label
							for="baseline">Op Cost Savings(1000's $) </label><br>
						<input id="pp" type="checkbox" name="custom" [disabled]="!showEnergy" value="PaybackPeriod" (change)="changeCostEvent($event)">
						<label for="baseline">Payback Period </label><br>
						<input id="tedi" type="checkbox" name="custom" [disabled]="!showTedi" value="Tedi" (change)="changeCostEvent($event)">
						<label for="baseline">TEDI (kWh/m2/yr) </label><br>
						<input id="tc" type="checkbox" name="custom" [disabled]="!showTedi" value="TediCost" (change)="changeCostEvent($event)">
						<label for="baseline">TEDI Cost (1000's $) </label>
					</div>
				   
				</div>
                </div>
            </div>
			</div>
			<div class="btnAlign">
				 <button (click)="goBack()" class="back" mat-raised-button color="default">Back</button>
				 <button [class.actcostStyle]="newisEditable=='true'" id="actcost" (click)="getCost()"
						[disabled]="toggleBool==true" type="button" mat-raised-button color="primary">OK</button>
			</div>
        </div>
		
    </div>
  
	</div>
